import {Router} from '@angular/router';
import {StudentService} from './../../services/student.service';
import {LocalStrorageService} from './../../services/local-strorage.service';
import {Student} from 'src/app/models/student';
import {Component, Input, OnInit} from '@angular/core';
import {AngularFireStorage} from '@angular/fire/storage';
import {finalize} from 'rxjs/operators';
import {Course} from '../../models/course';
import {CourseService} from '../../services/course.service';
import {SubjectTest} from '../../models/subject-test';
import {SubjectTestService} from '../../services/subject-test.service';

export type EditorType = 'course' | 'tests' | 'account';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {
  student: Student = new Student();
  selectedTestResult: any[];
  courses: Course[] = [];
  subjectTests: SubjectTest[] = [];
  currentStudent: Student = new Student();
  selectedSubjectTest: any;
  viewSubjectTest = true;
  @Input() newPhoto: Student;

  editor: EditorType = 'course';

  constructor(private localStorage: LocalStrorageService,
              private localStorageService: LocalStrorageService,
              private studentService: StudentService,
              private courseService: CourseService,
              private subjectTestService: SubjectTestService,
              private router: Router,
              private storage: AngularFireStorage) {
  }

  get showCourseTab(): boolean {
    return this.editor === 'course';
  }

  get showTestsTab(): boolean {
    return this.editor === 'tests';
  }

  get showAccountTab(): boolean {
    return this.editor === 'account';
  }

  ngOnInit(): void {
    this.student = this.localStorage.getStudent();

    this.studentService.getStudent(this.student.phone).then(res => {
      console.log(res);
      this.student = res;
    });
    this.getCourses();
  }

  getCourses(): void {
    this.courseService.getCourses().then((response: any) => {
      this.courses = response.data;
    });
  }

  viewTest(subjectTest: SubjectTest): void {
    this.viewSubjectTest = true;
    this.selectedSubjectTest = subjectTest;
    this.selectedTestResult = this.student.examResults.filter(item => item.subjectTestId === this.selectedSubjectTest.test._id);
    console.log(this.selectedSubjectTest);
  }

  logOut(): void {
    this.localStorageService.deleteStudent();
    this.student = this.localStorageService.getStudent();
    if (this.router.url !== '') {
      this.router.navigateByUrl('/');
    }
  }

  toggleEditor(type: EditorType): void {
    this.editor = type;
  }

  uploadFile($event: any): any {
    const file = $event.target.files[0] as File;
    const randomId = Math.random().toString(36).substring(2);
    const filePath = `students/${randomId}_${file.name}`;
    const ref = this.storage.ref(filePath);
    const task = ref.put(file);
    // get notified when the download URL is available
    task.snapshotChanges().pipe(
      finalize(async () => {
        const url = await ref.getDownloadURL().toPromise();
        this.student.profileImgUrl = url;
      })
    )
      .subscribe();
  }

  resetImgUrl() {
    this.newPhoto.profileImgUrl = '';
  }

  saveChanges(): void {
    const student = this.localStorage.getStudent();
    if (student.phone != this.student.phone) {
      this.student.phone = student.phone;
    }
    this.studentService.update(this.student).then(res => {
      this.localStorage.saveStudent(res);
      console.log('edited');
    });
  }
}
